"use client";
import { QueryClientProvider } from "@tanstack/react-query";
import type { ReactNode } from "react";
import { getBrowserQueryClient } from "./query-manager";

export default function TanStackQueryProvider({
  children,
}: {
  children: ReactNode;
}) {
  const queryClient = getBrowserQueryClient();

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}
